var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarThing3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 270,
    viewBox: "0 0 274 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.107 99.5L147.27 99.8961L147.599 99.6206L200.61 55.1286L172.481 116.665L172.289 117.084L172.749 117.109L242.623 120.836L177.369 146.097L176.939 146.264L177.251 146.603L223.114 196.348L158.899 170.537L158.502 170.377L158.47 170.804L153.427 237.48L127.911 175.674L127.747 175.278L127.419 175.553L74.4076 220.045L102.537 158.509L102.729 158.09L102.268 158.065L32.3943 154.338L97.6488 129.076L98.0787 128.91L97.7663 128.571L51.9035 78.8259L116.118 104.637L116.516 104.797L116.548 104.37L121.59 37.6942L147.107 99.5Z",
    fill: "#FE3176",
    stroke: "black",
    strokeWidth: 0.627527
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.674 30.4659L145.694 93.4911L199.771 48.1051L171.063 110.906L242.398 114.712L175.779 140.501L222.584 191.269L157.079 164.939L151.938 232.93L125.918 169.904L71.8409 215.29L100.549 152.489L29.2139 148.684L95.8324 122.895L49.027 72.1269L114.532 98.4569L119.674 30.4659Z",
    fill: "#DBF429"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarThing3);
export default __webpack_public_path__ + "static/media/star_thing_3.fabe6b19.svg";
export { ForwardRef as ReactComponent };